module.exports = __webpack_public_path__ + "img/paper-download.62cfcd00.svg";